const Report = {
  sales: 'Sales Revenue',
  profit: 'Net Profits',
  tax: 'Tax Report',
  driverEarning: 'Driver Earning',
  companyEarning: 'Company Earning',
};
export default Report;
